<div class="ui-dialog-container" style="width: 100%">
  <div class="ui-dialog-content" style="display: flex; align-items: center; flex-direction: column">
    <h2>
      {{ "forms.prescription.type." + careplanPrescription?.prescriptionType | translate }}
      {{ officialCareplan?.careplan?.display ? "(" + officialCareplan.careplan.display + ")" : "" }} &nbsp;
    </h2>

    <div class="spinner-container" *ngIf="isLoading">
      <mat-spinner></mat-spinner>
    </div>

    <ng-container *ngIf="!isLoading">
      <form [formGroup]="prescriptionForm" style="display: flex; flex-wrap: wrap; gap: 30px" *ngIf="isReimbursement">
        <div>
          <div class="flexRow mt-1" *ngIf="careplanPrescription.prescriptionType !== PRESCRIPTION_TYPE.HOME_CARE_MOROCCO">
            <p>{{ "forms.prescription.isRenew" | translate }}</p>
            <button
              type="button"
              [class]="patientRegistrationService.prescription ? 'colored' : ''"
              id="isRenew1"
              mat-raised-button
              (click)="radioButtonClicked(true, 'isRenew')"
            >
              {{ "common.yes" | translate }}
            </button>
            <button
              [class]="patientRegistrationService.prescription ? '' : 'colored'"
              type="button"
              id="isRenew0"
              mat-raised-button
              (click)="radioButtonClicked(false, 'isRenew')"
            >
              {{ "common.no" | translate }}
            </button>
          </div>
          <p
            class="mt-1"
            *ngIf="prescriptionPeriodMax !== 12 && careplanPrescription.prescriptionType !== PRESCRIPTION_TYPE.HOME_CARE_MOROCCO"
          >
            {{
              ("forms.prescription.prescriptionMaxDuration" | translate) +
                " : " +
                prescriptionPeriodMax +
                " " +
                ("periodUnit." + prescriptionPeriodTimeUnit + ".singPlural" | translate)
            }}
          </p>
          <div class="flexRow mt-1">
            <mat-form-field>
              <mat-label>{{ "schedule.dateFrom" | translate }}</mat-label>
              <input
                matInput
                [matDatepicker]="startDate"
                formControlName="startDate"
                [placeholder]="'schedule.dateFrom' | translate"
                required
                (dateChange)="setEndDate()"
              />
              <mat-datepicker-toggle matSuffix [for]="startDate"></mat-datepicker-toggle>
              <mat-datepicker #startDate></mat-datepicker>
            </mat-form-field>
            <mat-form-field class="numberSelect" *ngIf="!isEndlessPrescription">
              <mat-label>{{ "forms.prescription.prescriptionDuration" | translate }}</mat-label>
              <mat-select
                formControlName="prescriptionDuration"
                (selectionChange)="setEndDate($event.value)"
                *ngIf="careplanPrescription.prescriptionType !== PRESCRIPTION_TYPE.HOME_CARE_MOROCCO"
              >
                <mat-option *ngFor="let _ of [].constructor(prescriptionPeriodMax); let index = index" [value]="index + 1">
                  {{ index + 1 }}
                </mat-option>
              </mat-select>
              <input
                matInput
                (keypress)="
                  preventCharacter($event, [PREVENTCHARACTER.letter, PREVENTCHARACTER.specialCharExceptPlus], 'prescriptionDuration')
                "
                formControlName="prescriptionDuration"
                *ngIf="careplanPrescription.prescriptionType === PRESCRIPTION_TYPE.HOME_CARE_MOROCCO"
                (change)="setEndDate($event.value)"
              />
            </mat-form-field>
          </div>
          <div class="mt-1 flexRow">
            <mat-form-field *ngIf="!isEndlessPrescription">
              <mat-label>{{ "forms.prescription.endDate" | translate }}</mat-label>
              <input
                matInput
                [matDatepicker]="endDate"
                [placeholder]="'forms.prescription.endDate' | translate"
                [disabled]="true"
                [value]="endDateCalculated"
              />
              <mat-datepicker-toggle matSuffix [for]="endDate"></mat-datepicker-toggle>
              <mat-datepicker #endDate></mat-datepicker>
            </mat-form-field>
            <mat-slide-toggle
              *ngIf="careplanPrescription.prescriptionType === PRESCRIPTION_TYPE.HOME_CARE_MOROCCO"
              (change)="onNoEndDateChange($event)"
            >
              {{ "mydrugs.noEndDate" | translate }}
            </mat-slide-toggle>
          </div>

          <div class="flexRow mt-1" *ngIf="careplanPrescription.prescriptionType !== PRESCRIPTION_TYPE.HOME_CARE_MOROCCO">
            <p>{{ "forms.prescription.renewable" | translate }}</p>
            <button
              [class]="
                patientRegistrationService.prescription
                  ? patientRegistrationService.prescription?.occurence?.renewal
                    ? 'colored'
                    : ''
                  : 'colored'
              "
              type="button"
              id="renewable1"
              mat-raised-button
              (click)="radioButtonClicked(true, 'renewable')"
            >
              {{ "common.yes" | translate }}
            </button>
            <button
              type="button"
              id="renewable0"
              [class]="
                patientRegistrationService.prescription
                  ? patientRegistrationService.prescription?.occurence?.renewal
                    ? ''
                    : 'colored'
                  : ''
              "
              mat-raised-button
              (click)="radioButtonClicked(false, 'renewable')"
            >
              {{ "common.no" | translate }}
            </button>
          </div>
          <!-- not used yet
          <div class="flexRow mt-1">
            <p>{{ "forms.prescription.autoRenew" | translate }}</p>
            <button type="button" id="autoRenew1" mat-raised-button (click)="radioButtonClicked(true, 'autoRenew')">
              {{ "common.yes" | translate }}
            </button>
            <button type="button" id="autoRenew0" mat-raised-button (click)="radioButtonClicked(false, 'autoRenew')">
              {{ "common.no" | translate }}
            </button>
          </div>
        -->
          <div *ngIf="careplanPrescription.prescriptionType !== PRESCRIPTION_TYPE.HOME_CARE_MOROCCO">
            <p class="mt-1 mb-1" *ngIf="renewPeriodMax !== 12 && prescriptionForm?.get('renewable').value">
              {{
                ("forms.prescription.renewMaxDuration" | translate) +
                  " : " +
                  renewPeriodMax +
                  " " +
                  ("periodUnit." + renewPeriodTimeUnit + ".singPlural" | translate)
              }}
            </p>
            <mat-form-field class="numberSelect" *ngIf="prescriptionForm?.get('renewable').value">
              <mat-label style="overflow: visible">{{ "forms.prescription.renewDuration" | translate }}</mat-label>
              <mat-select formControlName="renewDuration" (selectionChange)="onDurationChange($event.value)">
                <mat-option *ngFor="let _ of [].constructor(renewPeriodMax); let index = index" [value]="index + 1">
                  {{ index + 1 }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div *ngIf="careplanPrescription.prescriptionType !== PRESCRIPTION_TYPE.HOME_CARE_MOROCCO">
          <p class="mt-1">{{ "forms.prescription.billingMethod" | translate }}</p>
          <div class="flexRow mt-1" *ngIf="officialCareplan.careplan.cumulableBillingAuthorized">
            <button
              type="button"
              id="isCumulative0"
              [class]="patientRegistrationService.prescriptionConfig?.periodicity?.frequency > 1 ? '' : 'colored'"
              mat-raised-button
              (click)="radioButtonClicked(false, 'isCumulative')"
            >
              {{ "periodUnit.lastmonth" | translate }}
            </button>
            <button
              type="button"
              id="isCumulative1"
              [class]="patientRegistrationService.prescriptionConfig?.periodicity?.frequency > 1 ? 'colored' : ''"
              mat-raised-button
              (click)="radioButtonClicked(true, 'isCumulative')"
            >
              {{ "forms.prescription.cumulative" | translate }}
            </button>
            <mat-form-field class="" *ngIf="prescriptionForm?.get('isCumulative').value">
              <mat-label>{{ "forms.prescription.nbMonthCumulative" | translate }}</mat-label>
              <mat-select formControlName="nbMonthCumulative">
                <mat-option *ngFor="let _ of [].constructor(prescriptionDuration ?? 6); let i = index" [value]="i + 1">
                  {{ i + 1 }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="flexRow mt-1" *ngIf="availableCoefficients?.length">
            <p>{{ "forms.prescription.coefficientIncrease" | translate }}</p>
            <mat-form-field class="numberSelect">
              <mat-label>{{ "forms.prescription.coefficientIncrease" | translate }}</mat-label>
              <mat-select formControlName="coefficientIncrease" (selectionChange)="setMonthlyPaidAmount()">
                <mat-option *ngFor="let coefficient of availableCoefficients" [value]="coefficient">
                  {{ coefficient }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="flexRow mt-1">
            <p *ngIf="pricings?.length < 2">{{ "forms.prescription.monthlyPaidAmount" | translate }}</p>
            <mat-form-field *ngIf="pricings?.length > 1" class="numberSelect">
              <mat-label>{{ "periodUnit.lastmonth" | translate }}</mat-label>
              <mat-select formControlName="pricingIndex" (selectionChange)="setMonthlyPaidAmount()">
                <mat-option *ngFor="let p of pricings; let i = index" [value]="i">
                  {{ p.month }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field>
              <mat-label>{{ "forms.prescription.monthlyPaidAmount" | translate }}</mat-label>
              <input matInput type="number" formControlName="monthlyPaidAmount" />
            </mat-form-field>
          </div>
          <div class="flexRow mt-1">
            <p>{{ "forms.prescription.chargeNurse" | translate }}</p>
            <mat-form-field>
              <mat-label>{{ "forms.prescription.chargeNurse" | translate }}</mat-label>
              <mat-select formControlName="chargeNurse" (selectionChange)="checkCanSkip()">
                <mat-option [value]="null" class="unselect">- {{ "forms.null" | translate }} -</mat-option>
                <mat-option *ngFor="let nurse of availableNurses" [value]="nurse"
                  >{{ nurse | getPractitionerName : practitionerService }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="flexRow mt-1">
            <p>{{ "forms.prescription.chargeDoctor" | translate }}</p>
            <mat-form-field>
              <mat-label>{{ "forms.prescription.chargeDoctor" | translate }}</mat-label>
              <mat-select formControlName="chargeDoctor" (selectionChange)="onDoctorChange()">
                <mat-option [value]="null" class="unselect">- {{ "forms.null" | translate }} -</mat-option>
                <mat-option *ngFor="let doc of availableDoctors" [value]="doc"
                  >{{ doc | getPractitionerName : practitionerService }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <mat-checkbox class="mt-1 mb-1" formControlName="needValidation" labelPosition="before" *ngIf="showNeedValidationCheckbox">{{
            "forms.prescription.needValidation" | translate
          }}</mat-checkbox>
          <br />
          <div style="display: flex; align-items: center; gap: 1rem; margin-bottom: 20px; flex-wrap: wrap">
            <button
              type="button"
              mat-raised-button
              (click)="fileInput.click()"
              [disabled]="templatesSelected?.length > 0"
              *ngIf="('dashboard/document' | isAuthorized : 'POST' | async) === true"
            >
              {{ "forms.prescription.importBtn" | translate }}
            </button>
            <input
              hidden
              (change)="import($event)"
              #fileInput
              type="file"
              accept="application/pdf,image/jpg,image/jpeg,image/png"
              size="5000000"
            />
            {{ "common.or" | translate }}
            <button
              type="button"
              mat-raised-button
              (click)="addTemplate()"
              [disabled]="documents?.length > 0"
              *ngIf="('dashboard/practitionerTemplate/autoCompleted' | isAuthorized | async) === true"
            >
              {{ (templatesSelected?.length ? "forms.prescription.editTemplateBtn" : "forms.prescription.addTemplateBtn") | translate }}
            </button>
          </div>
          <span
            *ngFor="let file of documents; let index = index"
            class="file-name"
            style="display: flex; flex-direction: row; justify-content: center; align-items: center"
            ><p>{{ file.name }}</p>
            <mat-icon class="custom-icon-small sub-align fail" style="margin-left: 5px" (click)="onDeleteDocument(index)">delete</mat-icon>
          </span>
          <span
            *ngFor="let template of templatesSelected; let index = index"
            class="file-name"
            style="display: flex; flex-direction: row; justify-content: center; align-items: center"
          >
            <mat-icon
              class="custom-icon-small sub-align"
              style="margin-right: 5px; cursor: pointer"
              (click)="showAutoCompletedTemplate(template)"
              *ngIf="('dashboard/practitionerTemplate/autoCompleted' | isAuthorized | async) === true"
              >file_copy</mat-icon
            >
            <p>{{ template.name }}</p>
            <mat-icon
              class="custom-icon-small sub-align fail"
              style="margin-left: 5px; cursor: pointer"
              (click)="onDeleteDocument(index, 'template')"
              >delete</mat-icon
            >
          </span>
          <span
            *ngFor="let linkedDoc of linkedDocuments; let index = index"
            class="file-name"
            style="display: flex; flex-direction: row; justify-content: center; align-items: center"
            ><p>{{ linkedDoc.display }}</p>
            <mat-icon class="custom-icon-small sub-align fail" style="margin-left: 5px" (click)="onDeleteDocument(index, 'linked')"
              >delete</mat-icon
            >
          </span>
        </div>
      </form>
      <app-prescription-devices-form
        *ngIf="careplanPrescription.prescriptionType === PRESCRIPTION_TYPE.BYTEFLIES_DEVICE"
        [careplanPrescription]="careplanPrescription"
        (finish)="next()"
      ></app-prescription-devices-form>
    </ng-container>
  </div>
  <div class="ui-dialog-actions">
    <button mat-raised-button color="primary" (click)="save()" style="float: right" [disabled]="isLoading">
      {{ (isLastStep ? "model.patient.finish" : "globalHelp.nextSlide") | translate }}
    </button>
    <button
      mat-raised-button
      *ngIf="!careplanPrescription?.required"
      [disabled]="!canSkip && isLoading"
      (click)="next()"
      style="float: right; margin-right: 10px"
    >
      {{ (isLastStep ? "forms.skipAndFinish" : "globalHelp.skip") | translate }}
    </button>
  </div>
</div>
